import { HistoryTerm } from '@empathy/search-types';
import { HistoryState } from '../../../models';
import { HISTORY_MUTATIONS_KEYS } from '../history.const';
import { HistoryMutation } from '../history.interfaces';

export class RemoveQueryHistoryMutation implements HistoryMutation {
  mutations = {
    [HISTORY_MUTATIONS_KEYS.removeQueryHistory]: (localState: HistoryState, historyTerm: HistoryTerm) => {
      const position = localState.queryHistory.indexOf(historyTerm);
      if (position >= 0) {
        localState.queryHistory.splice(position, 1);
      }
    }
  };
}
